import React from "react";
import LegalLayout from "@/components/LegalLayout";
import { SITE } from "@/lib/site";

const Terms = () => {
  return (
    <LegalLayout
      title="Terms"
      effectiveDate="June 11, 2026"
      testIdRoot="terms"
    >
      <p className="lead">
        By using this website, you agree to these basic terms.
      </p>

      <h2>Fictional Universe</h2>
      <p>
        Shadows of the Infinite is a fictional science-fantasy universe created
        by Federico C. Quiñones. Cinder Archive transmissions, Black Salt
        language, archive references, and related materials are part of a
        fictional reader experience unless clearly stated otherwise.
      </p>

      <h2>No Real Emergency or Recruitment</h2>
      <p>
        Nothing on this website should be interpreted as a real-world
        emergency, classified operation, recruitment effort, government
        message, or intelligence notice.
      </p>

      <h2>Intellectual Property</h2>
      <p>
        Shadows of the Infinite
        <sup className="ml-[1px] text-[0.7em]">™</sup>, Echoes of Cinder,
        Cinder Archive, Black Salt, and related original text, worldbuilding,
        characters, settings, concepts, and materials are owned by Federico C.
        Quiñones unless otherwise stated.
      </p>
      <p>© 2026 Federico C. Quiñones. All rights reserved.</p>
      <p>
        SHADOWS OF THE INFINITE
        <sup className="ml-[1px] text-[0.7em]">™</sup> is a trademark of
        Federico C. Quiñones. Trademark application pending.
      </p>

      <h2>Permitted Use</h2>
      <p>
        You may view and share links to the website for personal,
        non-commercial purposes.
      </p>
      <p>
        You may not copy, reproduce, sell, modify, scrape, redistribute, or
        commercially exploit website content without written permission.
      </p>

      <h2>No Final Cover Art Released</h2>
      <p>
        Any temporary visuals, placeholder imagery, or development references
        shown before official release are not final cover art unless clearly
        identified as final.
      </p>

      <h2>Professional Inquiries</h2>
      <p>
        For rights, press, review, editorial, or professional inquiries,
        contact:
      </p>
      <p>
        <a
          href={`mailto:${SITE.inquiriesEmail}`}
          data-testid="terms-contact-email"
          className="link-cinder font-display italic text-xl"
        >
          {SITE.inquiriesEmail}
        </a>
      </p>

      <h2>Changes</h2>
      <p>
        These Terms may be updated as the website and launch infrastructure
        develop.
      </p>
    </LegalLayout>
  );
};

export default Terms;
